import * as pixi from 'pixi.js';
import _throttle from 'lodash/throttle';
import anime from 'animejs';
import './WobblyController.scss';
import { WobblyLine } from '../wobblyline/WobblyLine';

export class WobblyController {
  app = null;
  containerEl = null;
  contentEl = null;
  mouseX = null;
  mouseY = null;
  pages = [];
  scrollPosition = 0;
  overflowHeight = 30;
  shapeOffsetX = 0;

  constructor({ containerEl, contentEl }) {
    this.containerEl = containerEl;
    this.contentEl = contentEl;
    this.app = new pixi.Application({
      width: 800,
      height: 800,
      antialias: true,
      transparent: false,
      autoDensity: true,
      backgroundColor: 0x0,
      preserveDrawingBuffer: true,
      clearBeforeRender: true,
    });

    this.containerEl.appendChild(this.app.view);

    let previousColor = 0x0;
    for (const page of contentEl.children) {
      // if no color is available, assume it's ignored
      if (page.dataset.color == null) continue;
      if (page.dataset.color === '') // repeat color of last one
        page.dataset.color = previousColor;
      this.pages.push({ page, line: null });
      previousColor = page.dataset.color;
    }

    this.createLines();
    this.updateLines();

    window.addEventListener('resize', this.resize);
    window.addEventListener('scroll', this.onScroll);
    window.addEventListener('mousemove', this.onMouseMove);
    window.addEventListener('touchstart', this.onTap);

    this.resize();

  }

  createLines() {
    // Todo: remove this line - used for testing
    //this.pages = this.pages.splice(0, 1);
    //

    for (const item of this.pages) {
      const itemGraphics = new pixi.Graphics();
      this.app.stage.addChild(itemGraphics);
      const wobblyLine = new WobblyLine({app: this.app, color: item.page.dataset.color, graphics: itemGraphics });
      item.line = wobblyLine;
    }
  }

  updateLines() {
    for (const item of this.pages) {
      const { line, page } = item;
      const offsetHeight = page.offsetHeight + this.overflowHeight * 3; // higher multiplier due to mobile
      line.update(this.shapeOffsetX, page.offsetTop - this.scrollPosition, page.offsetWidth, offsetHeight, this.overflowHeight);
    }
  }
  onTap = _throttle((e) => {
    const { clientX, clientY } = e.touches[0];
    this.showWave({ clientX, clientY });
  }, 1000);

  onScroll = (e) => {
    this.scrollPosition = window.scrollY;
    this.updateLines();
  }

  onMouseMove = (e) => {
    this.mouseX = e.clientX;
    this.mouseY = e.clientY;
    for (let i = 1; i < this.pages.length; i++) { // don't hit test on first line
      const item = this.pages[i];
      item.line.onMouseMove({mouseX: this.mouseX, mouseY: this.mouseY});
    }
  }
  showWave = (e) => {
    const pushDistance = 100;
    const touchDistance = 150;
    // const item = this.pages[Math.floor(Math.random() * this.pages.length - 1) + 1]; // ignore top (heading)
    for (const item of this.pages) {
      const dist = Math.abs(item.line.shapeOffsetY - e.clientY);
      if (dist > touchDistance) {
        continue;
      }
      let direction = item.line.shapeOffsetY - e.clientY < 0 ? -1 : 1;

      const wave = {
        x: e.clientX,
        y: - pushDistance * direction,
      };
      anime({
        targets: wave,
        y: pushDistance * direction,
        duration: 200,
        easing: 'linear',
        update: () => {
          item.line.onMouseMove({ mouseX: wave.x, mouseY: item.line.shapeOffsetY + wave.y });
        },
      });

    }
  }

  resize = () => {
    this.app.renderer.resize(this.containerEl.offsetWidth, this.containerEl.offsetHeight);
    this.updateLines();
  }

  destroy() {
    this.app.destroy();

    window.removeEventListener('resize', this.resize);
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('mousemove', this.onMouseMove);
    window.removeEventListener('touchstart', this.onTap);
  }
}
